<!-- usado en pagina de resultados de busqueda -->
<div *ngIf="modelo==='normal'" class="mycontainer" onload="anchoPag()">
  <div class="busquedayFiltros">
    <div class="uplabel breadcrumb-row" *ngIf="categoriasClickeables.length > 0">
      <div class="categoria">
        <div *ngFor="let cate of categoriasClickeables; index as i; trackBy: trackByCate" class="mnsjae-breadcrumb">
          <div class="myborder" (click)="clickOnCate(cate.categoria,cate.activable)"
            *ngIf='(categoriasClickeables.length-1)!=i'>
            {{ cate.nombre }} <span class="separator">/</span>
          </div>
          <div class="myborder active" *ngIf='(categoriasClickeables.length-1)==i'>
            {{ cate.nombre }}
          </div>
        </div>
      </div>
    </div>
    <div class="uplabel results-row">
      <div class="mnsjae-results">
        <span class="count">{{articulosFiltrados.length}}</span>
        <span class="label">Resultados</span>
        <span *ngIf="myExtrasResultado.textodebusqueda" class="query">
          en “{{myExtrasResultado.textodebusqueda}}”
        </span>
      </div>
    </div>
    <div class="filtros">
      <div class="ordenarpor">
        <div class="labelfiltro">
          Ordenar por:
        </div>
        <selector-generico *ngFor="let item of gaseosas" (onSelect)="seleccionadoFiltro($event)" [mode]="'selector'"
          [catego]="item" [defaultSelect]="filtroElegidoNombre"></selector-generico>
      </div>
      <div class="busquedafiltro">
        <div class="search-input-wrapper">
          <input type="text" class="inputFilter" [(ngModel)]="searchTerm" (input)="filtrarArticulos()" 
            placeholder="Buscar en ésta categoria...">
          <span class="search-icon">
            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="articulos">
    <productos-view *ngFor="let i of [1,2,3,4,5,6,7,8]" [mode]="'skeleton'"></productos-view>
  </div>

  <div *ngIf="!loading && articulosFiltrados.length>0; else sinArticulos" class="articulos" id="articulos">
    <ng-container *ngFor="let articulo of articulosFiltrados; trackBy: trackByArticulo">
      <productos-view [articulo]="articulo"></productos-view>
    </ng-container>
  </div>

  <ng-template #sinArticulos>
    <div class="contanerselectors articulos">
      <div class="mnsjae" style="width:100%; text-align: center;">
        No se encontraron resultados para su búsqueda.
      </div>
    </div>
  </ng-template>

  <div class="contanerselectors" style="justify-content: center;">
    <paginador-mmax-app [paginas]="numeropaginas" (paginaElegida)="onPageSelect($event)"> </paginador-mmax-app>
  </div>
</div>

<div *ngIf="modelo==='postcheckout'" class="checkoutblock">
  <ng-container *ngFor="let item of articulos; trackBy: trackByArticulo">
    <productos-view *ngIf="!esDescuentoGlobalTipoCliente(item)" [articulo]="item"
      [mode]="'postcheckout'"></productos-view>
  </ng-container>
</div>
<!-- esto se muestra en la landing page en la seccion Promociones del Mes  -->
<div *ngIf="modelo==='promos-land'" style="position: relative;">
  <div class="slimarticulos" id="slimarticulosPromos">
    <ng-container *ngFor="let articulo of articulos; let i = index; trackBy: trackByArticulo">
      <ng-container *ngFor="let promos of articulo.getPromos()">
        <promocion-card class="produc-view" [promocion]="promos"></promocion-card>
      </ng-container>
    </ng-container>
  </div>
  <button class="control prev" (pointerdown)="onPreviousClickPr()">
    <span class="arrow left"></span>
  </button>
  <button class="control next" (pointerdown)="onNextClickPr()">
    <span class="arrow right"></span>
  </button>
</div>
<!-- esto se muestra en la landing page en seccion Ofertas del Mes -->
<div *ngIf="modelo==='ofertas-land'" style="position: relative;">
  <div class="slimarticulos" id="slimarticulosOfertas" #ofertasScroll [class.is-centered]="!needsScrollOfertas">
    <ng-container *ngFor="let item of articulos; let i = index; trackBy: trackByArticulo">
      <productos-view class="produc-view" [mode]="'ofertas-land'" [articulo]="item"></productos-view>
    </ng-container>
  </div>
  <ng-container *ngIf="needsScrollOfertas">
    <button class="control prev" (pointerdown)="onPreviousClickOf()">
      <span class="arrow left"></span>
    </button>
    <button class="control next" (pointerdown)="onNextClickOf()">
      <span class="arrow right"></span>
    </button>
  </ng-container>
</div>

<!-- esto se muestra en la landing page en la seccion Destacados -->
<div *ngIf="modelo==='destacados-land'">
  <div *ngIf="loading" class="articulos-destacados">
    <productos-view *ngFor="let i of [1,2,3,4]" [mode]="'skeleton'"></productos-view>
  </div>
  <div *ngIf="!loading" class="articulos-destacados">
    <ng-container *ngFor="let articulo of articulos; trackBy: trackByArticulo">
      <productos-view [articulo]="articulo" [mode]="'destacado'"></productos-view>
    </ng-container>
  </div>
</div>

<!-- carrito -->
<div *ngIf="modelo==='resumendetail'">

  <div class="mytabla header" [class.sin-bultos]="!permiteBultosEnListado()">
    <div style="grid-area: eliminar;"></div> <!-- Empty space for the X button column -->
    <div style="grid-area: imagen;"></div> <!-- Empty space for the image column -->
    <div class="prod center" style="grid-area: descripcion; justify-content: flex-start; padding-left: 1rem;">
      Producto
    </div>
    <div *ngIf='!ocultarPrecios' class="preciu center" style="grid-area: preciounidad;">
      Precio Unitario
    </div>
    <div class="canti center" style="grid-area: suma;">
      Unidades
    </div>
    <div *ngIf="permiteBultosEnListado()" class="bultos center" style="grid-area: bultos;">
      Bultos
    </div>
    <div *ngIf='!ocultarPrecios' class="preciureal center" style="grid-area: preciototal;">
      Subtotal
    </div>
  </div>

  <div class="tablacontainer">
    <ng-container *ngFor="let item of articulos; trackBy: trackByArticulo">
      <productos-view *ngIf="!esDescuentoGlobalTipoCliente(item)" [mode]="'detalle'" [articulo]="item"></productos-view>
    </ng-container>
    <!-- Descuento del combo como fila propia (imagen/nombre de la promo),
         en vez de repetir el precio total del combo en cada artículo. -->
    <div *ngFor="let combo of combosEnCarrito" class="mytabla" [class.sin-bultos]="!permiteBultosEnListado()">
      <div style="grid-area: eliminar;"></div>
      <div style="grid-area: imagen;">
        <img [src]="combo.getFotoImagen()||combo.getFoto()" [alt]="combo.getNombrePromocion()" loading="lazy"
          style="width: 100%; max-width: 60px; object-fit: contain;">
      </div>
      <div style="grid-area: descripcion; justify-content: flex-start; padding-left: 1rem;">
        Descuento: {{ combo.getNombrePromocion() }}
      </div>
      <div *ngIf='!ocultarPrecios' style="grid-area: preciounidad;"></div>
      <div style="grid-area: suma;"></div>
      <div *ngIf="permiteBultosEnListado()" style="grid-area: bultos;"></div>
      <div *ngIf='!ocultarPrecios' style="grid-area: preciototal;" class="center">
        -{{ combo.getDescontadoTotal() | currency }}
      </div>
    </div>
    <!-- Descuento global por Tipo Cliente OL como fila propia (sin selector
         de cantidad: no tiene sentido "sumarle unidades" a un descuento). -->
    <div *ngFor="let promoGlobal of descuentosGlobalesEnCarrito" class="mytabla" [class.sin-bultos]="!permiteBultosEnListado()">
      <div style="grid-area: eliminar;"></div>
      <div style="grid-area: imagen;"></div>
      <div style="grid-area: descripcion; justify-content: flex-start; padding-left: 1rem;">
        Descuento: {{ promoGlobal.getNombrePromocion() }}
      </div>
      <div *ngIf='!ocultarPrecios' style="grid-area: preciounidad;"></div>
      <div style="grid-area: suma;"></div>
      <div *ngIf="permiteBultosEnListado()" style="grid-area: bultos;"></div>
      <div *ngIf='!ocultarPrecios' style="grid-area: preciototal;" class="center">
        -{{ montoDescuentoGlobal(promoGlobal) | currency }}
      </div>
    </div>
  </div>

</div>
<!-- historials -->
<div *ngIf="modelo==='historialDetail'">

  <div class="mytabladetail header">
    <div class="prod center">
      Producto
    </div>
    <ng-container *ngIf='!ocultarPrecios'>
      <div class="preciu center">
        Precio Unitario
      </div>
    </ng-container>
    <div class="canti center">
      Cantidad
    </div>
    <ng-container *ngIf='!ocultarPrecios'>
      <div class="preciureal center">
        Precio Total
      </div>
    </ng-container>
    <div class="prodInfo center">
      Productos Info.
    </div>
    <!-- <div class="options center">

    </div> -->
  </div>
  <div class="tablacontainer">
    <productos-view [mode]="'detalletrakin'" *ngFor="let item of articulos; trackBy: trackByArticulo"
      [articulo]="item"></productos-view>
  </div>

</div>

<div *ngIf="modelo==='oferta'" class="ofertas-capa">
  <div class="ofertas">
    <productos-view *ngFor="let item of articulos; trackBy: trackByArticulo" [articulo]="item" [mode]="'ofertas'"
      class="promosView" style="margin-bottom: 1em;">
    </productos-view>
  </div>
  <div class="contanerselectors" style="justify-content: center;" *ngIf="numeropaginasOfertas>1">
    <paginador-mmax-app [paginas]="numeropaginasOfertas" (paginaElegida)="onPageSelectOferta($event)">
    </paginador-mmax-app>
  </div>
</div>

<div *ngIf="modelo==='promociones'" class="promos">
  <productos-view *ngFor="let promos of articulos; trackBy: trackByArticulo" [articulo]="promos" [mode]="'promos'"
    class="promosView"></productos-view>
</div>